import { NavLink } from 'react-router-dom';

function NavItems(props) {
    const navList = [
        'Home',
        'About',
        'Contact Us',
        'Portfolio'
    ];
    return (
        <div>
            <ul className='hidden md:flex'>
                {
                    navList.map((navItem) => {
                        return <li className='p-6'>
                            <NavLink to={`/${navItem.replace(" ", "")}`}>
                                {navItem}
                            </NavLink>
                        </li>;
                    })
                }
            </ul>

            {/* Responsive Menu Bar */}
            <ul className={`md:hidden block duration-300 text-center fixed bg-black ${props.menuToggle ? "left-0" : "left-[-100%]"} text-white top-[55px] w-full h-screen`}>
                {
                    navList.map((navItem) => {
                        return <li className='p-6'>
                            <NavLink to={`/${navItem.replace(" ", "")}`}>
                                {navItem}
                            </NavLink>
                        </li>;
                    })
                }
            </ul>
        </div>
    )
}

export default NavItems